<template>
  <div id="app" :class="(hideSidebar === true ? 'hideInsp' : '')">
    
    
    <header id="header">
      <a id="backhome" href="/"><img alt="köhler." src="../assets/koehler_logo.svg"></a>
    </header>


      
      <nav id="metanav">

        <div class="search-box" :class=" opensearch && 'opensearch' " >
          <div class="searchfield-box" v-if="opensearch"><search :items="products" class="searchfield-box"></search></div>
          <a v-on:click="opensearch = !opensearch" class="searchToggle"><i class="icon icon-search"></i></a>
        </div>

        <div class="metanav-inner">
  <!--         <router-link to="/"><i class="icon icon-search mobile-icon-search"></i></router-link> -->
          <router-link v-if="user && user.role == 'admin' " class="userdata toBackend" to="/manager">Backend</router-link>
          <router-link to="/" class="userdata"><i class="icon icon-home mobile-icon-home"></i> <span class="kdn">Start</span></router-link>
          <router-link to="/projects" class="userdata"><i class="icon icon-projects mobile-icon-projects"></i> <span class="kdn">Projekte</span></router-link>
          <router-link to="/favorites"><i :class=" 'icon icon-favourite ' + ( user && user.fav && user.fav.length > 0 ? 'icon-favourite-full' :'' )"></i><span class="counter" v-if="user && user.fav && user.fav.length > 0">{{user.fav.length}}</span></router-link>
          <router-link v-if="user" to="/user" class="userdata"><i class="icon icon-user mobile-icon-user"></i> <span class="kdn" v-if="user">{{user.firstname}}</span></router-link>
  <!--         <router-link to="/about" class="user"><i class="icon icon-user"></i></router-link> -->
  <!--         <router-link to="/shop"><i class="icon icon-help"></i></router-link> -->
          <router-link v-if="user" to="/login" title="Logout"><i class="icon icon-logout mobile-icon-logout"></i></router-link>
        </div>

        <div class="toggleLegalsSub" :class=" openLegalsSub && 'openLegalsSub' ">
          <div class="switchLegalSub" v-on:click=" openLegalsSub = !openLegalsSub "><i class="icon icon-hamburger" ></i></div>
          <div class="legals-sub-bg" v-if="openLegalsSub" v-on:click=" openLegalsSub = false "></div>
          <div class="legals-sub" v-if="openLegalsSub" v-on:click=" openLegalsSub = false ">
            <a href="tel:+492116016020">0211 - 601 602 0</a>
            <a href="mailto:info@koehler-klinker.de">E-Mail schreiben</a>
            <hr/>
            <router-link :to="{ name: 'AboutPage' }">Über die Klinker-App</router-link>
            <router-link :to="{ name: 'KoehlerPage' }">Über köhler.</router-link>
            <hr/>
            <router-link :to="{ name: 'ImprintPage' }">Impressum</router-link>
            <router-link :to="{ name: 'PrivacyPage' }">Datenschutzerklärung</router-link>
          </div>
        </div>

      </nav>

    <main id="maincontent">
        <div v-if="alert.message" :class="`alert ${alert.type}`">{{alert.message}}</div>
        <transition-page><router-view v-on:loginRequired="openLoginOverlay = true"></router-view></transition-page>
    </main>

    
      <div class="inspire">
          
          <h2>Get inspired ...</h2>
          
          <div class="inspire-scrollbox">
          
              <div class="inspire-item">
                <a href="https://www.koehler-klinker.de/riemchen/" target="_blank" rel="noopener">
                  <img :src=" config.appUrl + '/upload/content/koehler-wunschkonzert-hero-app.jpeg'">
                <div class="desc">
                  <div>
                  <h2>Wunschkonzert</h2>
                  <p>Exklusive Riemchen bringen Musik an den Bau</p>
                  </div>
                </div>
                </a>
              </div>
              <div class="inspire-item">
                <a href="https://www.koehler-klinker.de/fliesen/" target="_blank" rel="noopener">
                <img :src=" config.appUrl + '/upload/content/fliesen-koehler-hero-2019-1.jpg'">
                <div class="desc">
                  <div>
                  <h2>Der WOW Effekt</h2>
                  <p>Italienische Fliesen von Atlas Concorde</p>
                  </div>
                </div>
                </a>
              </div>
    
              <div class="inspire-item">
                <a href="https://www.koehler-klinker.de/inspiration/klinker-aus-dem-ringofen/" target="_blank" rel="noopener">
                <img :src=" config.appUrl + '/upload/content/ringofen-klinker-1.jpg'">
                <div class="desc">
                  <div>
                  <h2>Die Welt braucht mehr Unikate</h2>
                  <p>Klinker aus dem Ringofen</p>
                  </div>
                </div>
                </a>
              </div>
    
              <div class="inspire-item">
                <a href="https://www.koehler-klinker.de/inspiration/monolithisches-bauen/" target="_blank" rel="noopener">
                <img :src=" config.appUrl + '/upload/content/koehler-monolithisches-bauen-hero-1.jpg'">
                <div class="desc">
                  <div>
                  <h2>Monolithisches Bauen</h2>
                  <p>Das Prinzip Mono als neue Philosophie</p>
                  </div>
                </div>
                </a>
              </div>
          
          
        </div>
      </div>
      
    
<!--
    <div id="fastcontact">
      <a href="tel:+492114155773">0211 4155773</a>
    </div>
-->

    <login-overlay v-if="openLoginOverlay" v-on:closeLoginOverlay="openLoginOverlay = false"></login-overlay>

  </div>
</template>

<script>
import config from '../_config/config';
import Search from '../components/Search';
import LoginOverlay from '../components/LoginOverlay';
import TransitionPage from '../transitions/TransitionPage.vue';

/*
import products       from '../data/etar2.json';
import categories     from '../data/categories.json';
*/

export default {
    name: 'app',
    components: {
      Search,
      TransitionPage,
      LoginOverlay,
      
    },
    data() {
      return {
        //products: products,
        //categories: categories,
        mobilemenu: false,
        userdatasubm: false,
        hideSidebar: false,
        opensearch: false,
        openLoginOverlay: false,
        openLegalsSub: false,
      }
    },
    computed: {
      
        currentRoute (){
          //console.log(this.$router);
          return this.$route.name;
        },
        status (){
            return this.$store.state.authentication.status
        },
        user () {
            return this.$store.state.authentication.user
        },  
        alert () {
            return this.$store.state.alert
        },
        products(){
          return this.$store.state.products.all
        },

    },
    created(){
        this.config = config
        this.$store.dispatch('products/getAll');
    },
    watch:{
      
      alert: function(){
        if( this.alert.message == "Access denied.")  this.openLoginOverlay = true ;
      },
      
      user: function(){
        if(this.user) this.openLoginOverlay = false;
      },
        $route (to, from ){
            // clear alert on location change
            //console.log(to);
            
            this.opensearch = false;
            this.openLoginOverlay = false
            
            var h = ['LoginPage','AdminPage','Product','SignUp', 'ProductsAdmin']
            this.hideSidebar = h.indexOf( to.name ) != -1 ?  true : false;
            
            //console.log(this.hideSidebar);
            
            this.$store.dispatch('alert/clear');
            //console.log( $route );
/*
            alert('alert cleared');
            console.log(from);
            console.log(next);
*/
        }
    },
    methods: {
      toggleMenu: function(){
         this.mobilemenu = !this.mobilemenu
       },
      closeMenu: function(){
        console.log('close Menu clicked');
        this.mobilemenu = false;
        return;
      }
    }
    
};
</script>
<style lang="scss">
  
  /*
    color cats
    blau: #007eba
    gelb: #f8c63d
    gruen: #5eb245
    lila: #5f2a79
    rot: #d8222a
    
    gruen: #ffffff
  */
  
/* ==========================================================================
   Chrome Frame prompt
   ========================================================================== */

.chromeframe {
    margin: 0.2em 0;
    background: #ccc;
    color: #000;
    padding: 0.2em 0;
}

  
  
body { background: #343434 /* fixed url(../assets/koehler-bg-01-p.jpg) no-repeat center center; background-size: cover */; }

@media screen and ( min-width: 40.0633333em) {
  body { background: #343434 fixed url(../assets/koehler-bg-01.jpg) no-repeat center center; background-size: cover; }
}

#app {
  font-family: 'Ubuntu', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #fff;
}

.page { position: relative; padding: 8.888em 0 9.88888em 0; height: auto !important; min-height: 90vh; }
@media screen and ( min-width: 40.0633333em) {
  .page { position: relative; padding: 9rem 0 9.88888em 0; height: auto; min-height: 90vh; }
}

.section { padding: 2.79999999em 0; }

a,
a:visited,
a:active,
a:focus { color: #fff; }

h1 { margin: 0; padding: 0.171333em 0; font-size: 1.433333rem;  }
h2 { margin: 0; padding: 0.771333em 0; font-size: 1.433333rem; }

  h2,h3 { font-weight: 600; }
  h1 { font-weight: 600;  }
  .loginpage h1 { padding: 0; }
  p { color: #ffffff; line-height: 1.7rem; font-size: 1.1rem; }

h4 { margin: 0; padding: 0 0 0.63333em; font-size: 1.033333rem; }

hr { height: 1px; background: #fff; border: 0; outline: 0; overflow: hidden; opacity: 0.5 }

  .button { background: rgba(0,0,0,0.2); border: 0; color: #fff; border: 2px solid #fff; padding: 0.4333333em 1.8333333em; border-radius: 1px; transition: background 0.3s, transform 0.5s; font-size: 1.2rem; text-decoration: none; }
  .button:hover { background: rgba(0,0,0,0.4); transform: scale(1.00) }

  button { background: rgba(0,0,0,0.2); border: 0; color: #fff; border: 2px solid #fff; padding: 0.4333333em 1.8333333em; border-radius: 1px; transition: background 0.3s, transform 0.5s; font-size: 1.2rem; text-decoration: none; }
  button:hover { background: rgba(0,0,0,0.7); transform: scale(1.00) }
  button { outline: none !important; }

.alert { position: fixed; z-index: 1000; top: 50%; left: 50%; transform: translate(-50%,-50%); background: #fff; border: 2px solid #dc1200; color: #dc1200; }

#header { position: fixed; z-index: 10; top: 0; left: 0; right: auto; display: flex; justify-content: space-between; align-items: center; padding: 0; }

#backhome { positon: static; display: block; width: 100%; max-width: 14em; height: auto; padding: 0; margin-left: 0; }
#backhome img { display: block; width: 100%; }

@media screen and ( min-width: 40.0633333em) {
  #backhome { display: block; width: 100%; max-width: 18em; }
}




.icon { display: block; width: 1.877rem; height: 1.877rem; transition: transform 0.1s ease-in-out; position: relative; transform: scale(1.0011); }
.icon:hover { transform: scale(1.1111); }
.icon-favourite { background: url(/img/icons-white/favourite.svg) center center no-repeat; background-size: contain; }
.icon-favourite-full { background: url(/img/icons-red/favourite-full.svg) center center no-repeat; background-size: contain; }

.icon-home { background: url(/img/icons-white/grid.svg) center center no-repeat; background-size: 90%; }
.icon-projects { background: url(/img/icons-white/stats-alt.svg) center center no-repeat; background-size: 115%; }
.icon-share { background: url(/img/icons-white/share-ios.svg) center center no-repeat; background-size: 100%; }

.icon-user { background: url(/img/icons-white/user.svg) center center no-repeat; background-size: contain; }
.icon-help { background: url(/img/icons-white/help.svg) center center no-repeat; background-size: contain; }
.icon-basket { background: url(/img/icons-white/bag.svg) center center no-repeat; background-size: 125%; width: 1.877rem; }
.icon-basket-full { background: url(/img/icons-white/bag-full.svg) center center no-repeat; background-size: 125%; width: 1.877rem; }
.icon-search { background: url(/img/icons-white/search.svg) center center no-repeat; background-size: 115%; }
.icon-chevron-right { background: url(/img/icons-gray/chevron-right.svg) center center no-repeat; background-size: 100%; }
.icon-logout { background: url(/img/icons-white/exit.svg) center center no-repeat; background-size: contain; }
.icon-info { background: url(/img/icons-white/info.svg) center center no-repeat; background-size: contain; }

.icon-ok { background: url(/img/icons-white/ok.svg) center center no-repeat; background-size: contain; }
.icon-save { background: url(/img/icons-white/save.svg) center center no-repeat; background-size: contain; }
.icon-move { background: url(/img/icons-custom-white/move.svg) center center no-repeat; background-size: contain; }
.icon-bin { background: url(/img/icons-white/bin.svg) center center no-repeat; background-size: contain; }

.icon-hamburger { background: url(/img/icons-white/hamburger.svg) center center no-repeat; background-size: contain; }



.icon-plus { background: url(/img/icons-white/add.svg) center center no-repeat; background-size: contain; }
.icon-minus { background: url(/img/icons-white/remove.svg) center center no-repeat; background-size: contain; }
.icon-remove { background: url(/img/icons-white/delete.svg) center center no-repeat; background-size: contain; }


h1 i.icon { display: inline-block; vertical-align: middle; margin-right: 0.43333em; margin-top: -4px; }



#metanav {  
  position: fixed; z-index: 10; bottom: 0; left: 0; right: 0; }
  
#metanav .metanav-inner {
  display: flex; justify-content: space-between; align-items: center; 
  padding: 0.93333em .9333rem 2.07777rem;
  white-space: nowrap;
  display: flex;
  align-items: center;
  background: rgba(0,0,0,0.8);
  border-radius: 3px;
}
#metanav a {
    font-weight: bold;
    color: #ffffff;
    margin: 0 0.433333em;
}




#metanav a { position: relative; }
span.counter { background: none; color: #e30613; font-size: 0.7rem; text-decoration: none;
  position: absolute; top:-0.3rem; left: -0.63333rem; width: 1.3333rem; height: 1.33333rem; line-height: 1.33333rem; text-align: center;
  border-radius: 1rem;
}
.icon-favourite-full + span.counter { color: #000 !important; background: #fff; opacity: 0.5; }
.icon-basket-full + span.counter { color: #000 !important; background: #fff; }


#metanav .userdata { display: flex; align-items: center; width: auto; height: auto; padding: 0 0.633333em; transition: transform 0.1s ease-in-out; font-weight: normal;  line-height: 1;  text-decoration: none !important; }
#metanav .userdata .kdn { display: none; text-decoration: none; margin: 0.333em 0 0.333rem 0.33333rem; font-weight: normal; color: #efefef;}

#metanav .toBackend { display: none; }

@media screen and ( min-width: 64em) {
  #metanav { position: fixed; z-index: 10; bottom: auto; top: 1.3333em; left: auto; right: 1.33333em; display: flex;  }
  #metanav .metanav-inner {
  display: flex; justify-content: space-between; align-items: center; 
  padding: .9333rem 0.733rem .9333rem 0.333rem;
  white-space: nowrap;
  display: flex;
  align-items: center;
  background: rgba(0,0,0,0.55);  
  }

  #metanav .toBackend { display: block; }
  #metanav .userdata .kdn { display: block; }
  #metanav a:hover .icon { transform: scale(1.1111); }

}




.search-box { 
  position: fixed; top: 0.9333333rem; right: 0.93333rem; z-index: 1001;
  padding: .9333rem 0.6333rem;
  white-space: nowrap;
  display: flex;
  align-items: center;
  background: rgba(0,0,0,0.8);
  border-radius: 3px;
  display: none;
  }
.searchfield-box { position: fixed; top: 2rem; left: 0.93333em; right: 0.933333em; width: auto; max-width: 100%; }

.search-box:before {
  content:""; position: fixed; top: 0; left: 0; right: 0; background: rgba(0,0,0,0.9); overflow: hidden; opacity: 0; transition: opacity 0.3s ease;
}
.search-box.opensearch:before {
  opacity: 1; bottom: 0;
}

@media screen and ( min-width: 64em) {
.search-box { display: block;
  position: relative; top: auto; right: auto;
  margin-right: 0.3333rem;
  display: flex; justify-content: space-between; align-items: center; 
  padding: .9333rem 0.6333rem;
  white-space: nowrap;
  display: flex;
  align-items: center;
  background: rgba(0,0,0,0.55);  
  }
  .searchfield-box { width: 12em; max-width: 12em; position: relative; top: 0; left: auto; right: auto; }
  .search-box:before { display: none !important; } 
}


/* .router-link-active { background: rgba(0,0,0,0.9) } */



/*
  ---------------------------------------------------
  legals-sub
  --------------------------------------------------
  */

.toggleLegalsSub { 
  position: fixed; top: 0.9333333rem; right: 0.93333rem; z-index: 1001;
  }
.switchLegalSub { 
  padding: .9333rem 1.0333rem;
  white-space: nowrap;
  display: flex;
  align-items: center;
  background: rgba(0,0,0,0.8);
  border-radius: 3px;
  }
.toggleLegalsSub i { cursor: pointer; }  
.toggleLegalsSub.openLegalsSub .switchLegalSub { background: rgba(0,0,0,0.9) } 
  
@media screen and ( min-width: 64em) {
  .toggleLegalsSub {
    position: relative; top: auto; left: auto; right: auto;
    margin-left: 0.3333rem;
    display: flex; justify-content: space-between; align-items: center; 
}
.switchLegalSub { 
    padding: .9333rem 0.933rem;
    white-space: nowrap;
    display: flex;
    align-items: center;
    background: rgba(0,0,0,0.55);  
    }
}
.legals-sub:after { content:""; position: absolute; top: -8px; right: 1.3333rem; border: 8px solid transparent; border-top: 0; border-bottom: 8px solid rgba(0,0,0,0.8); }
.legals-sub { position: absolute; top: 4.222rem; right: 0; min-width: 15rem; background: rgba(0,0,0,1); padding: 0.63333rem; border-radius: 3px; }
.legals-sub a { display: block; text-decoration: none; padding: 0.6333rem 1.43333em 0.6333rem 0.6333rem; margin: 0 0 2px 0!important; font-weight: normal !important; background: rgba(255,255,255,0.1); width: 100%; transition: background 0.3s; }
.legals-sub a:hover { background: rgba(255,255,255,0.2); }
.legals-sub a:last-child { margin: 0!important; } 
.legals-sub-bg { 
  position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(45,45,45,0.8); content:""; z-index: -5;
}






.inspire { display: block; width: 100%; height: auto; padding: 0 0 5.333rem 0; margin: 0;  }
.inspire h2 { padding-left: 1.5666rem; }
.inspire img { display: block; width: 100%; max-width: 100%; height: auto; }
.inspire-item { margin: 0 0 0.43333em 0; position: relative; padding-top: 55.55%; overflow: hidden; }
.inspire-item a { position: absolute; top: 0; right: 0; left: 0; bottom: 0; text-decoration: none;  }
.inspire-item a div.desc { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); 
  margin: 0; padding: 0 0 0.93333em 0; padding-left: 1.5666rem; 
  height: auto; display: flex; flex-wrap: wrap; align-items: flex-end;
  }
.inspire-item a div h2,
.inspire-item a div p { margin: 0; padding: 0; width: 100%; line-height: 1.1; height: auto; text-align: left; opacity: 1; }

@media screen and ( min-width: 64em) {
  .inspire { position: fixed; max-width: 18rem; top: 9rem; bottom: 0; left: 0; right: auto; padding: 0; z-index: 2; }
  .inspire-scrollbox { position: absolute; left: 0; right: 0; top: 4em; bottom: 0; border: 0 solid #fff; overflow: scroll; -webkit-overflow-scrolling: touch; }
  
  .inspire-scrollbox::-webkit-scrollbar { display: none;  width: 0; background: transparent; }
  .inspire-scrollbox { -ms-overflow-style: none;  /* IE and Edge */ scrollbar-width: none;  /* Firefox */ }
  
  .inspire-item a div.desc { background: rgba(0,0,0,0.4); opacity: 1; transition: opacity 0.3s ease, background 0.3s ease; }
  .inspire-item a:hover  div.desc { background: rgba(0,0,0,0.6); opacity: 1; }
  
.inspire-item a div h2,
.inspire-item a div p { margin: 0; padding: 0; width: 100%; line-height: 1.1; height: auto; text-align: left; opacity: 0; }
  
 .inspire-item a:hover div h2,
.inspire-item a:hover div p { opacity: 1 } 
}




/* 
  Transiton Effect
  for pages without sidebar
  */
#maincontent { height: auto; position: relative; z-index: 8; overflow: hidden; min-height: 90vh; }

@media screen and ( min-width: 64em ) {
  #maincontent {  transition: padding 0.3s ease;  margin: 0 0 0 19rem; padding: 0 ; }
  .hideInsp #maincontent { padding: 0; margin: 0; z-index: 3; }

  .inspire { transform: perspective(0) rotateY(0) translate(0,0); opacity: 1; transition: all 0.5s ease; }
  .hideInsp .inspire { transform: perspective(400px) rotateY(45deg) translate(-100px,0); opacity: 0 }
}


.openmenu { display:block; width: 2.777em; max-width: 3em; background:  url(/img/icons-green/hamburger.svg) -8px center no-repeat; background-size: 2.4em; cursor: pointer; color: #ffffff; text-indent: -9999px; margin-left: 0.83333em; }

@media screen and ( min-width: 768px) {
  .openmenu { display: none; }
  .mobile-icon-search { display: none; }
}



  .columns { margin: 0 0 0 0; }
  .columns img { display: block; max-width: 100%; border-radius: 3px; overflow: hidden;  }  
  .column { display: block; padding: 0.9333333em; text-align: left; }
  @media screen and ( min-width: 768px) {    
    .column { display: block; padding: 0.9333333em 0.9333333em 0 0.9333333em; text-align: left; }
    .columns { max-width: 64em; margin: 0 0.37333em 0 0; }
    .columns.max { width: 100%; max-width: 100%; margin: 0 auto; padding: 0 0.9333333em; }
    .columns.max .column { padding: 0.9333333em; flex: 1 1 auto; border: 0 solid red; }
    .columns.max img { padding: 0; }
    .columns.flex { display: flex; }
    .columns.wrap { flex-wrap: wrap; }
    .columns.valign-middle { align-items: center; }
    .columns.align-center { justify-content: center; }
    .columns.space-between { justify-content: space-between; }
    .columns.valign-top { align-items:flex-start; }
    .columns.half .column { flex: 1 1 50%; max-width: 50%; }
    .columns.third .column { flex: 1 1 33.3333%; max-width: 33.3333%; }
    .columns.quarter .column { flex: 1 1 25%; max-width: 25%; }

    .columns.one-two-thirds .column { flex: 0 0 33.333%; }
    .columns.one-two-thirds .column:first-child { flex: 0 0 66.666%; }


    .columns.p12 { max-width: 100%; margin: 1.5333333em; }
    .columns.p12 .column { flex: 1 1 8.33333%; max-width: 8.333333%; padding: 0.3333333em; }
    
    img.round { border-radius: 100%; max-width: 20em; margin: 0 auto; }
    .column.text-right { text-align: right; }
    
  }



.flex-group { display: flex;justify-content: space-between; align-items: center;}






#fastcontact { position: fixed; bottom: 0; left: 0; right: 0; background: #ffffff; text-align: center; }
#fastcontact a { display: inline-block; color: #fff; text-decoration: none; font-weight: bold; padding: 0.933333333em 0.933333333em 0.933333333em 3.4333333333em;
  background: url(/img/icons-white/phone.svg) 0.933333333em center no-repeat; background-size: 1.9em; cursor: pointer;
  }

@media screen and ( min-width: 768px) {
  #fastcontact { left: auto; bottom: auto; top: 16%; transform: translateX( calc(100% - 3.49999em) ); transition: transform 0.3s ease; border-radius: 3px 0 0 3px; }
  #fastcontact:hover { transform: translateX( 0 ) }
}

#footer { position: fixed; bottom: 0; left: 0; color: #fff; background: none; z-index: 100; border: 1px solid red; display: none; }
#footer nav { white-space: nowrap; }
#footer .openLegalMenu { border: 0; background: rgba(0,0,0,0.8 ); border-radius: 100%; width: 2.444rem; height: 2.444rem; margin: 0; padding: 0; }
#footer .legal-menu { position: absolute; display: none; }






/* .gradient { height: 1.8777rem; width: 5.777rem; text-indent: 0; display: inline-block; } */
.gradient.blck { 
  background: rgb(0,0,0);
  background: -moz-linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(122,122,122,1) 100%);
  background: -webkit-linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(122,122,122,1) 100%);
  background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(122,122,122,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#7a7a7a",GradientType=1);
}
.gradient.yllw { 
  background: rgb(255,206,84);
  background: -moz-linear-gradient(270deg, rgba(215,206,180, 1) 20%, rgba(201, 183, 159, 1) 100%);
  background: -webkit-linear-gradient(270deg, rgba(215,206,180, 1)  20%, rgba(201, 183, 159, 1)  100%);
  background: linear-gradient(270deg, rgba(215,206,180, 1)  20%, rgba(201, 183, 159, 1)  100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffce54",endColorstr="#fffbdc",GradientType=1);
}
.gradient.wht {
  background: rgb(231,231,231);
  background: -moz-linear-gradient(270deg, rgba(123,123,123,1) 0%, rgba(251,251,251,1) 100%);
  background: -webkit-linear-gradient(270deg, rgba(123,123,123,1) 0%, rgba(251,251,251,1) 100%);
  background: linear-gradient(270deg, rgba(123,123,123,1) 0%, rgba(251,251,251,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#a7a7a7",endColorstr="#fbfbfb",GradientType=1);
}
.gradient.brwn { 
  background: rgb(65,32,0);
  background: -moz-linear-gradient(270deg, rgba(198,93,53, 1) 20%, rgba(86,31,20,1) 100%);
  background: -webkit-linear-gradient(270deg, rgba(198,93,53, 1) 20%, rgba(86,31,20,1) 100%);
  background: linear-gradient(270deg, rgba(198,93,53, 1) 20%, rgba(86,31,20,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#412000",endColorstr="#b00000",GradientType=1);
}



.app-overlay { position: fixed; z-index: 10011; top: 0; left: 0; right: 0; bottom: 0; background: rgba(75,75,75,0); display: flex; justify-content: center; align-items: center; padding: 1.43333em;  }
.app-overlay-inner { background: #000; width: 90%; max-width: 30em; border-radius: 3px; padding: 0; position: relative; margin-top: 1rem; }
.app-overlay-close { position: absolute; top: 0.9333rem; right: 0.9333rem; font-size: 1rem;line-height: 1.877rem; height: 1.877rem; width: 1.877rem; background: url(/img/icons-white/close.svg) center center no-repeat; text-indent: -9999px; background-size: 110%; transition:transform 0.35s ease; transform: rotate(0); }
.app-overlay-close:hover { transform: rotate(270deg); }

.shortinfo { font-size: 0.833rem; line-height: 1.3; padding: 0; border-radius: 1px; margin: 0 0 0.6333em 0; }
.app-overlay .overlay-header { background: rgba(255,255,255,0.1); padding: 0 1.333em 0; }
.app-overlay .overlay-header h2 { padding: 0; margin: 0;}
.app-overlay .overlay-header p { padding-bottom: 1.33333em; }
.app-overlay .overlay-body { padding: 0.93333em 0.933333em 1.43333em; }






#loader {
    display: block;
    position: absolute;
    left: 50%;
    top: 9em;
    width: 150px;
    height: 150px;
    margin: -75px 0 0 -75px;
    border-radius: 50%;
    border: 4px solid transparent;
    border-top-color: rgba(0, 0, 0, 0.25);

    -webkit-animation: spin 2s linear infinite; /* Chrome, Opera 15+, Safari 5+ */
    animation: spin 2s linear infinite; /* Chrome, Firefox 16+, IE 10+, Opera */

    z-index: -1;
}

    #loader:before {
        content: "";
        position: absolute;
        top: 5px;
        left: 5px;
        right: 5px;
        bottom: 5px;
        border-radius: 50%;
        border: 4px solid transparent;
        border-top-color: rgba(0, 0, 0, 0.5);

        -webkit-animation: spin 3s linear infinite; /* Chrome, Opera 15+, Safari 5+ */
        animation: spin 3s linear infinite; /* Chrome, Firefox 16+, IE 10+, Opera */
    }

    #loader:after {
        content: "";
        position: absolute;
        top: 15px;
        left: 15px;
        right: 15px;
        bottom: 15px;
        border-radius: 50%;
        border: 4px solid transparent;
        border-top-color: #000000;

        -webkit-animation: spin 1.5s linear infinite; /* Chrome, Opera 15+, Safari 5+ */
          animation: spin 1.5s linear infinite; /* Chrome, Firefox 16+, IE 10+, Opera */
    }

    @-webkit-keyframes spin {
        0%   { 
            -webkit-transform: rotate(0deg);  /* Chrome, Opera 15+, Safari 3.1+ */
            -ms-transform: rotate(0deg);  /* IE 9 */
            transform: rotate(0deg);  /* Firefox 16+, IE 10+, Opera */
        }
        100% {
            -webkit-transform: rotate(360deg);  /* Chrome, Opera 15+, Safari 3.1+ */
            -ms-transform: rotate(360deg);  /* IE 9 */
            transform: rotate(360deg);  /* Firefox 16+, IE 10+, Opera */
        }
    }
    @keyframes spin {
        0%   { 
            -webkit-transform: rotate(0deg);  /* Chrome, Opera 15+, Safari 3.1+ */
            -ms-transform: rotate(0deg);  /* IE 9 */
            transform: rotate(0deg);  /* Firefox 16+, IE 10+, Opera */
        }
        100% {
            -webkit-transform: rotate(360deg);  /* Chrome, Opera 15+, Safari 3.1+ */
            -ms-transform: rotate(360deg);  /* IE 9 */
            transform: rotate(360deg);  /* Firefox 16+, IE 10+, Opera */
        }
    }

    #loader-wrapper .loader-section {
        position: fixed;
        top: 0;
        width: 51%;
        height: 100%;
        background: #222222;
        z-index: 1000;
        -webkit-transform: translateX(0);  /* Chrome, Opera 15+, Safari 3.1+ */
        -ms-transform: translateX(0);  /* IE 9 */
        transform: translateX(0);  /* Firefox 16+, IE 10+, Opera */
    }

    #loader-wrapper .loader-section.section-left {
        left: 0;
    }

    #loader-wrapper .loader-section.section-right {
        right: 0;
    }

    /* Loaded */
    .loaded #loader-wrapper .loader-section.section-left {
        -webkit-transform: translateX(-100%);  /* Chrome, Opera 15+, Safari 3.1+ */
            -ms-transform: translateX(-100%);  /* IE 9 */
                transform: translateX(-100%);  /* Firefox 16+, IE 10+, Opera */

        -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);  
                transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
    }

    .loaded #loader-wrapper .loader-section.section-right {
        -webkit-transform: translateX(100%);  /* Chrome, Opera 15+, Safari 3.1+ */
            -ms-transform: translateX(100%);  /* IE 9 */
                transform: translateX(100%);  /* Firefox 16+, IE 10+, Opera */

-webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);  
        transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
    }
    
    .loaded #loader {
        opacity: 0;
        -webkit-transition: all 0.3s ease-out;  
                transition: all 0.3s ease-out;
    }
    .loaded #loader-wrapper {
        visibility: hidden;

        -webkit-transform: translateY(-100%);  /* Chrome, Opera 15+, Safari 3.1+ */
            -ms-transform: translateY(-100%);  /* IE 9 */
                transform: translateY(-100%);  /* Firefox 16+, IE 10+, Opera */

        -webkit-transition: all 0.3s 1s ease-out;  
                transition: all 0.3s 1s ease-out;
    }


  .p-meta { display: block; padding: 0 !important; margin: 0; position: relative; }
  .actions { position: relative; top: 0; left: 0; right: 0; border-radius: 2px; padding: 0.33333em 0 0.33333em 0; white-space: nowrap; }
  .actions a { display: block; margin-left:0; padding: 0.6222rem 1.0333em; background: rgba(0,0,0,0.4); margin-bottom: 1px; transition: background 0.3s; }
  .actions a i, 
  .actions a span { display: inline-block; line-height: 1.877rem; height: 1.877rem; vertical-align: middle; padding-left: 0.6333em;  }
  
  @media screen and ( min-width: 40em) {    
    .p-meta { display: flex; justify-content: space-between; align-items: center; }
    .actions { position: absolute; top: -3.3333rem; left: auto; right: 0; border-radius: 2px; padding: 0.33333em 0 0.33333em 0; white-space: nowrap; }
    .actions a { display: inline-block; background: none; margin-left: 1.433333em; padding: 0; cursor: pointer; }
    .actions { position: absolute; top: -0.3333em; right: 0.53333em; background: rgba(0,0,0,0.4); border-radius: 2px; padding: 0.33333em 1.4333em 0.33333em 0; white-space: nowrap; }
    .actions a:hover i { transform: scale(1.1111); }
  }



  .content-page { position: relative; padding: 9rem 0 9.88888em 0; height: 100%; min-height: 100vh; }
  .content-page h2 { padding-top: 0.13333em; }
  .content-page .button { display: block; background: rgba(0,0,0,0.4); color: #fff; border: 1px solid transparent;; padding: 0.93333em 2.73333333em; border-radius: 3px; text-align: center; width: auto; margin: 0.9333em 0.6333em 0 0; cursor: pointer; font-weight: bold; transition: background 0.3s, border 0.3s; font-size: 1rem; white-space: nowrap; }
  .content-page .button[disabled] { opacity: 0.4; }
  .content-page .button:hover { background: rgba(0,0,0,0.6); border: 1px solid rgba(255,255,255,0.5); }

  .content-page p { color: #ffffff; line-height: 1.7rem; font-size: 1rem; }
  .content-page ul {}
  .content-page ul li { color: #ffffff; line-height: 1.7rem; font-size: 1rem; }

  @media screen and ( min-width: 40em) {    
  .content-page .button { display: inline-block; width: auto; }
  }


</style>
